import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";

const initialState = {
  listTrackingLink: [],
  isGetTrackingLinks: false,
  isCreateTrackingLinks: false,
  isUpdateTrackingLink: false,
  isRemoveTrackingLink: false,
  total: 0,
};

export const trackingLinksSlice = createSlice({
  name: "tracking-links",
  initialState,
  reducers: {
    getTrackingLinksRequest: (state) => {
      state.isGetTrackingLinks = true;
    },
    getTrackingLinksSuccess: (state, { payload }) => {
      state.isGetTrackingLinks = false;
      state.listTrackingLink = payload.data;
      state.total = payload.total;
    },
    getTrackingLinksFailure: (state) => {
      state.isGetTrackingLinks = false;
    },
    createTrackingLinksRequest: (state) => {
      state.isCreateTrackingLinks = true;
    },
    createTrackingLinksSuccess: (state) => {
      state.isCreateTrackingLinks = false;
      state.total += 1;
      message.success("Create tracking link successfully!");
    },
    createTrackingLinksFailure: (state) => {
      state.isCreateTrackingLinks = false;
    },
    updateTrackingLinksRequest: (state) => {
      state.isUpdateTrackingLink = true;
    },
    updateTrackingLinksSuccess: (state, { payload }) => {
      state.isUpdateTrackingLink = false;
      state.listTrackingLink = payload;
      message.success("Update tracking link successfully!");
    },
    updateTrackingLinksFailure: (state) => {
      state.isUpdateTrackingLink = false;
    },
    removeTrackingLinksRequest: (state) => {
      state.isRemoveTrackingLink = true;
    },
    removeTrackingLinksSuccess: (state, { payload }) => {
      state.isRemoveTrackingLink = false;
      state.listTrackingLink = payload;
      state.total -= 1;
      message.success("Remove tracking link successfully!");
    },
    removeTrackingLinksFailure: (state) => {
      state.isRemoveTrackingLink = false;
    },
  },
});

export const {
  getTrackingLinksRequest,
  getTrackingLinksSuccess,
  getTrackingLinksFailure,
  createTrackingLinksRequest,
  createTrackingLinksSuccess,
  createTrackingLinksFailure,
  updateTrackingLinksRequest,
  updateTrackingLinksSuccess,
  updateTrackingLinksFailure,
  removeTrackingLinksRequest,
  removeTrackingLinksSuccess,
  removeTrackingLinksFailure,
} = trackingLinksSlice.actions;

export default trackingLinksSlice.reducer;
